  <div class="panel-schedule">

  <div class="panel-schedule__container" 
    [ngClass]="{'panel-schedule__container--open': status}">
    <div class="panel-schedule__main">
      <div class="panel-schedule__main__content">
        <flame-icon svgIcon="card-postpone-liquidation"></flame-icon>
        <span class="panel-schedule__main__title">Recarga programada</span>
        <div class="panel-schedule__main__flag" *ngIf="!status">Nuevo</div>
      </div>

      <label class="switch">
        <input type="checkbox" [checked]="status" (click)="changeStatus($event)" />
        <span class="slider"></span>
      </label>
    </div>
  </div>

  <div class="panel-schedule__details" *ngIf="status">
    <div class="panel-schedule__details-content">
      <ng-container *ngFor="let item of recharges">
          <div class="panel-schedule__details__item" *ngIf="item.active">
            <span class="panel-schedule__details--title">{{ item.label }}</span>
            <span class="panel-schedule__details--value">{{ item.value }}</span>
          </div>
      </ng-container>
    </div>

    <div class="panel-schedule__details-edit">
      <button class="btn-edit" flameButton (click)="editPaymentSchesule()" [disabled]="!activeEditRecharge">
        
        <flame-icon [ngClass]="{'icon': true,
                              'icon-disabled': !activeEditRecharge}"
          svgIcon="edit" size="s">
        </flame-icon>

        <span [ngClass]="{'panel-schedule__details--edit': true,
                        'panel-schedule__details--edit-disabled': !activeEditRecharge}">Editar</span>
      </button>
    </div>
  </div>

</div>